import { CultureResolvableMap, resolveForCurrentCulture } from "client_legacy/ndaw/culture";

export type TermsArticle = {
	name: string;
	url: string;
	trackingId: string;
};

export type TermsArticles = {
	customerLicenceAgreement: TermsArticle;
	dataProcessingAgreement: TermsArticle;
	serviceLevelAgreement: TermsArticle;
	acceptableUsePolicy: TermsArticle;
	responsibleDisclosurePolicy: TermsArticle;
};

export const TRUST_CENTER_SUPPORT_EMAIL_ADDRESS = "trust@workspace365.net";

export function getTermsArticles(): TermsArticles {
	const urls: TermsArticleUrls = resolveForCurrentCulture(TERMS_ARTICLE_URLS);

	return {
		customerLicenceAgreement: {
			name: "Customer Licence Agreement",
			url: urls.customerLicenceAgreement,
			trackingId: "customer-licence-agreement"
		},
		dataProcessingAgreement: {
			name: "Data Processing Agreement",
			url: urls.dataProcessingAgreement,
			trackingId: "data-processing-agreement"
		},
		serviceLevelAgreement: {
			name: "Service Level Agreement",
			url: urls.serviceLevelAgreement,
			trackingId: "service-level-agreement"
		},
		acceptableUsePolicy: {
			name: "Acceptable Use Policy",
			url: urls.acceptableUsePolicy,
			trackingId: "acceptable-use-policy"
		},
		responsibleDisclosurePolicy: {
			name: "Responsible Disclosure Policy",
			url: urls.responsibleDisclosurePolicy,
			trackingId: "responsible-disclosure-policy"
		}
	};
}

type TermsArticleUrls = {
	customerLicenceAgreement: string;
	dataProcessingAgreement: string;
	serviceLevelAgreement: string;
	acceptableUsePolicy: string;
	responsibleDisclosurePolicy: string;
};

const TERMS_ARTICLE_URLS: CultureResolvableMap<TermsArticleUrls> = {
	standard: {
		customerLicenceAgreement: "https://support.workspace365.net/en/articles/388793-customer-licence-agreement-cla",
		dataProcessingAgreement: "https://support.workspace365.net/en/articles/388786-data-processing-agreement-dpa",
		serviceLevelAgreement: "https://support.workspace365.net/en/articles/844182-service-level-agreement-sla",
		acceptableUsePolicy: "https://support.workspace365.net/en/articles/844131-acceptable-use-policy-aup",
		responsibleDisclosurePolicy: "https://support.workspace365.net/en/articles/388794-responsible-disclosure-policy"
	},
	nl: {
		customerLicenceAgreement: "https://support.workspace365.net/nl/articles/388793-klantlicentieovereenkomst-cla",
		dataProcessingAgreement: "https://support.workspace365.net/nl/articles/388786-verwerkersovereenkomst-vo-dpa",
		serviceLevelAgreement: "https://support.workspace365.net/nl/articles/844182-service-level-agreement-sla",
		acceptableUsePolicy: "https://support.workspace365.net/nl/articles/844131-acceptable-use-policy-aup",
		responsibleDisclosurePolicy: "https://support.workspace365.net/nl/articles/388794-responsible-disclosure-policy"
	}
};
